let pointsPromise, recordsPromise;
const readJson = async url => {
  const response = await fetch(url);
  if (!response.ok) throw new Error('Archive unavailable');
  return response.json();
};
export function archivePointPosition(point) {
  return [((point.x3 ?? point.x) - .5) * 3.8, (.5 - (point.y3 ?? point.y)) * 1.85, ((point.z3 ?? .5) - .5) * 3.8];
}
export function loadMuseumArchivePoints() {
  if (!pointsPromise) {
    pointsPromise = readJson('/assets/embedding-map.json').then(data => data.items.filter(p => p.route && p.title && archivePointPosition(p).every(Number.isFinite)));
    pointsPromise.catch(() => { pointsPromise = null; });
  }
  return pointsPromise;
}
export function loadMuseumArchiveRecords() {
  if (!recordsPromise) {
    recordsPromise = Promise.all([loadMuseumArchivePoints(), readJson('/assets/search-index.json')]).then(([points, records]) => {
      const sources = new Map(records.map(record => [`${record.route}#${record.anchor || ''}`, record]));
      return points.map(point => ({ ...sources.get(`${point.route}#${point.anchor || ''}`), ...point }));
    });
    recordsPromise.catch(() => { recordsPromise = null; });
  }
  return recordsPromise;
}
export function nearbyArchivePoints(points, id, limit = 6) {
  const selected = points.find(point => point.id === id);
  if (!selected) return [];
  const byId = new Map(points.map(point => [point.id, point]));
  // A 3D projection can bring unrelated passages close together. Only the
  // original embedding similarities can establish a connection.
  return (selected.neighbours || []).filter(link => link.score >= .45 && link.id !== id && byId.has(link.id))
    .slice().sort((a, b) => b.score - a.score || a.id - b.id).slice(0, limit).map(link => byId.get(link.id));
}
export function archiveExcerpt(record) {
  const text = String(record?.description || record?.body || '').replace(/Drag to spin\s*·\s*pinch to zoom\s*·\s*tap a point/gi, '').replace(/\s+/g, ' ').trim();
  if (text.length <= 380) return text;
  const end = text.slice(180, 380).search(/[.!?。！？](?:\s|$)/u);
  return end >= 0 ? text.slice(0, 181 + end) : `${text.slice(0, 377).replace(/\s+\S*$/, '')}…`;
}
